import styled from '@emotion/styled';

export const Wrapper = styled.div`
  text-align: center;
`;

export const Message = styled.div`
  margin: 32px 0;
`;

export const Buttons = styled.div`
  display: flex;
  gap: 32px;
  justify-content: center;

  button,
  a {
    min-width: 229px;
  }
`;
